import React, { useState, useEffect } from "react";
import { Icon, PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";
import StoryTrendLink from "app/links/StoryTrendLink";

import Flag from "components/common/Flag";
import QuickOptions from "components/display/QuickOptions";
import PinUserActivityToggle from "components/feed/feed-item/PinUserActivityToggle";
import NewStoryQuestionModal from "components/admin/settings/story-questions/NewStoryQuestionModal";
import VideoStudioContext from "components/stories/video-studio/contexts/VideoStudioContext";
import NewAIStoryQuestionModal from "components/admin/settings/story-questions/NewAIStoryQuestionModal";
import StoryQuestionModal from "components/admin/settings/story-questions/StoryQuestionModal";
import { AI_PROMPT_TYPE } from "app/utils/constants";

const ModalPromptHandler = ({ children, storyQuestion, onUpdate }) => {
  const [currentStoryQuestion, setCurrentStoryQuestion] = useState(storyQuestion);

  useEffect(() => {
    setCurrentStoryQuestion(storyQuestion);
  }, [storyQuestion]);

  const handleUpdate = updatedStoryQuestion => {
    setCurrentStoryQuestion(updatedStoryQuestion);
    if (onUpdate) {
      onUpdate(updatedStoryQuestion);
    }
  };

  if (!currentStoryQuestion) return null;

  return currentStoryQuestion.storyQuestionType === AI_PROMPT_TYPE ? (
    <NewAIStoryQuestionModal storyQuestion={currentStoryQuestion} onUpdate={handleUpdate}>
      {children}
    </NewAIStoryQuestionModal>
  ) : (
    <StoryQuestionModal
      storyQuestion={currentStoryQuestion}
      onUpdate={handleUpdate}
      selectedOptions={currentStoryQuestion.storyQuestionTags}
    >
      {children}
    </StoryQuestionModal>
  );
};


const QuickLinks = ({
  story,
  isMultiple,
  isAtFeed = true,
  userActivity,
  onUserActivityUpdate,
  isParentPrompt,
  onUpdate,
  onStoryUpdate,
  stories,
  storyQuestionId,
  trend,
  showCreateMontageButton = true
}) => {
  const { profile } = useProfile();
  const storyQuestion = story?.question;

  return (
    <QuickOptions>
      <ul className="dropdown-menu">
        {isAtFeed && (
          <>
            <li>
              <StoryTrendLink story={story}>
                <Icon icon="eye" />
                <Trans>View this story trend</Trans>
              </StoryTrendLink>
            </li>
            {profile.organizationAdmin && (
              <li>
                <PinUserActivityToggle
                  userActivity={userActivity}
                  onUserActivityUpdate={onUserActivityUpdate}
                />
              </li>
            )}
          </>
        )}
        {!isMultiple && !isParentPrompt && (
          <>
            <li>
              <ModalPromptHandler storyQuestion={storyQuestion} onUpdate={onUpdate}>
                {onTrigger => (
                  <PlainButton onClick={onTrigger}>
                    <Icon icon="edit" />
                    <Trans>Edit Prompt</Trans>
                  </PlainButton>
                )}
              </ModalPromptHandler>
            </li>
            <li>
              <Flag action="flagStory" options={{ storyId: story.id }}>
                {onTrigger => (
                  <PlainButton onClick={onTrigger}>
                    <Icon icon="ios-flag" />
                    <Trans>Flag this story as inappropriate</Trans>
                  </PlainButton>
                )}
              </Flag>
            </li>
          </>
        )}
        {isParentPrompt ? (
          <li>
            <NewStoryQuestionModal
              storyQuestion={story}
              onUpdate={onUpdate}
              selectedOptions={story.storyQuestionTags}
            >
              {onTrigger => (
                <PlainButton onClick={onTrigger}>
                  <Icon icon="edit-outlined" />
                  <Trans>Edit Story Trend</Trans>
                </PlainButton>
              )}
            </NewStoryQuestionModal>
          </li>
        ) : stories && showCreateMontageButton && (
          <li>
            <VideoStudioContext
              montage
              onStoryUpdate={onStoryUpdate}
              stories={stories}
              storyQuestionId={storyQuestionId}
              trend={trend}
            />
          </li>
        )}
      </ul>
    </QuickOptions>
  );
};

export default QuickLinks;
